<template>
  <form class="max-w-5xl" autocomplete="off" @submit.prevent="emit('save')">
    <div class="mt-10 mb-40 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
      <form-input v-model="mixedDataWithSeo.title" label="Title" class="md:col-span-4" :error-msg="result.title.$messages.join(' | ')" />

      <form-textarea v-model="mixedDataWithSeo.description" label="Description" class="col-span-4" />

      <hr class="col-span-4 mt-4">

      <form-input v-model="mixedDataWithSeo.ogTitle" label="og:title" class="md:col-span-4" />

      <form-textarea v-model="mixedDataWithSeo.ogDescription" label="og:description" class="col-span-4" />

      <form-input v-model="mixedDataWithSeo.ogImage" label="og:image URL" class="md:col-span-4" />

      <hr class="col-span-4 mt-4">

      <form-input v-model="mixedDataWithSeo.twitterTitle" label="twitter:title" class="md:col-span-4" />

      <form-textarea v-model="mixedDataWithSeo.twitterDescription" label="twitter:description" class="col-span-4" />

      <form-input v-model="mixedDataWithSeo.twitterImage" label="twitter:image URL" class="md:col-span-4" />

      <hr class="col-span-4 mt-4">

      <form-textarea v-model="mixedDataWithSeo.info" label="Info" class="col-span-full" />

      <form-textarea v-model="mixedDataWithSeo.fileTypes" label="Supported file types" class="col-span-full" :error-msg="result.fileTypes.$messages.join(' | ')" />

      <form-tags v-model="mixedDataWithSeo.programExtensions" label="Extensions (Open With)" class="md:col-span-full" />

      <form-textarea v-model="mixedDataWithSeo.usageInfo" label="Used by professionals" class="col-span-full" />
    </div>
  </form>
</template>

<script setup>
import { reactive, watch } from 'vue';
import FormInput from './FormInput.vue';
import FormTextarea from './FormTextarea.vue';
import FormTags from './FormTags.vue';
import useValidate from 'vue-tiny-validate';

const mixedDataWithSeo = defineModel('mixedDataWithSeo', {
  type: Object,
  default: () => ({
    name: ''
  })
});

const emit = defineEmits([ 'save' ]);

defineExpose({
  onValidate,
  getResult
});

const rules = reactive({
  title: {
    name: 'required',
    test: () => true,
    message: 'Title must not be empty.'
  },
  description: {
    name: 'required',
    test: () => true,
    message: 'Title must not be empty.'
  },
  ogTitle: {
    name: 'required',
    test: () => true,
    message: 'Title must not be empty.'
  },
  ogDescription: {
    name: 'required',
    test: () => true,
    message: 'Title must not be empty.'
  },
  ogImage: {
    name: 'required',
    test: () => true,
    message: 'Image must not be valid URL.'
  },
  twitterTitle: {
    name: 'required',
    test: () => true,
    message: 'Title must not be empty.'
  },
  twitterDescription: {
    name: 'required',
    test: () => true,
    message: 'Title must not be empty.'
  },
  twitterImage: {
    name: 'required',
    test: () => true,
    message: 'Image must not be valid URL.'
  },
  fileTypes: {
    name: 'required',
    test: value => Boolean(value),
    message: 'Type files must not be empty.'
  },
  programExtensions: {
    name: 'none',
    test: () => true,
    message: 'Extensions must not be empty.'
  }
});

watch(() => mixedDataWithSeo.value.ogTitle, val => mixedDataWithSeo.value.twitterTitle = val);
watch(() => mixedDataWithSeo.value.ogDescription, val => mixedDataWithSeo.value.twitterDescription = val);

const options = reactive({
  autoTest: true
});
const { result } = useValidate(mixedDataWithSeo, rules, options);

async function onValidate() {
  return await result.value.$test();
}

function getResult() {
  return result.value;
}
</script>
